require.register("local-data/poll_results/poll-demo.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "28aba4df-240c-4567-82fe-26aea9faf1a2",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 66,
            "questions": [
              {
                "id": 269,
                "text": "I keep a record of what I earn each month.",
                "answers": [
                  {
                    "id": 1064,
                    "text": "Yes",
                    "count": 200
                  },
                  {
                    "id": 1065,
                    "text": "No",
                    "count": 100
                  }
                ]
              },
              {
                "id": 271,
                "text": "I borrow someone elses Disney+ subscription",
                "answers": [
                  {
                    "id": 1064,
                    "text": "Yes",
                    "count": 200
                  },
                  {
                    "id": 1065,
                    "text": "No",
                    "count": 50
                  }
                ]
              },
              {
                "id": 272,
                "text": "I am a cable cutter.",
                "answers": [
                  {
                    "id": 1064,
                    "text": "Yes",
                    "count": 50
                  },
                  {
                    "id": 1065,
                    "text": "No",
                    "count": 200
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/surveys/primitives-em-survey.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "title": "Test Survey Title",
  "description": "Test Survey Description",
  "slug": "test-survey",
  "response_set_url": "https://localhost:3000/fake-api/test-survey",
  "sections": [
    {
      "title": "Test Title",
      "description": "Test Description",
      "index": 1,
      "questions": [
        {
          "id": 6,
          "text": "How would you test question?",
          "name": "TEST_NAME",
          "correct_feedback_text": "Test correct feedback text.",
          "correct_feedback_title": "Test Correct Title",
          "incorrect_feedback_title": "Test Incorrect Feedback Title",
          "incorrect_feedback_text": "Test Incorrect Feedback Text",
          "index": 0,
          "answers": [
            {
              "id": 10,
              "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
              "correct": true
            },
            {
              "id": 20,
              "text": "Consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
              "correct": false
            }
          ]
        },
        {
          "id": 15,
          "text": "How would you test question?",
          "name": "TEST_NAME",
          "display_type": "radio",
          "correct_feedback_text": "Test correct feedback text.",
          "correct_feedback_title": "Test Correct Title",
          "incorrect_feedback_title": "Test Incorrect Feedback Title",
          "incorrect_feedback_text": "Test Incorrect Feedback Text",
          "index": 2,
          "answers": [
            {
              "id": 30,
              "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
              "correct": true
            },
            {
              "id": 40,
              "text": "Consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
              "correct": false
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/customizations.json", function(exports, require, module) {
  module.exports = (function() {
return [
    {
      "type": "text-content-customization",
      "customizations": [
        {
          "type": "text-content-customization",
          "slug": "welcome_text",
          "enabled": "true",
          "custom_text": "This is a sample `text-content-customization` entry with the slug `welcome_text`."
        },
        {
          "type": "text-content-customization",
          "slug": "exit_text",
          "enabled": "true",
          "custom_text": "This is a sample `text-content-customization` entry with the slug `exit_text`."
        }
      ]
    },
    {
      "type": "image-content-customization",
      "customizations": [
        {
          "type": "image-content-customization",
          "slug": "exit_image",
          "enabled": "true",
          "url": "https://via.placeholder.com/480x240?text=exit_image"
        }
      ]
    },
    {
      "type": "video-content-customization",
      "customizations": [
        {
          "type": "video-content-customization",
          "slug": "intro_video",
          "enabled": "true",
          "url": "https://youtu.be/RtWw3OtdBkw",
          "provider": "youtube",
          "attribute_id": "ytplayer",
          "attribute_type": "text/html",
          "attribute_width": "1010",
          "attribute_height": "575",
          "attribute_frameborder": 0,
          "attribute_allowfullscreen": true,
          "param_autoplay": 0,
          "param_modestbranding": 1,
          "param_rel": 0,
          "param_showinfo": 0,
          "param_iv_load_policy": 3,
          "param_theme": "light",
          "param_enablejsapi": 1,
          "video_id": "RtWw3OtdBkw"
        }
      ]
    }
  ]
  })();
});

require.register("local-data/assessments/rec-m3-pre.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa1b",
  "passing_grade": 70,
  "questions": [
    {
      "id": 1,
      "text": "Local sample for m2-pre-assessment. Since online sellers can duplicate reviews to bump their ratings, what can you do to make sure you are reading authentic reviews of a product?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Read the reviews of the item on many different websites to see if they are consistent or agree with each other."
        },
        {
          "id": "B",
          "text": "Only read reviews from the advertisers or the store website where you are buying it."
        },
        {
          "id": "C",
          "text": "Read reviews only by social media influencers and their followers."
        },
        {
          "id": "D",
          "text": "Don't read online reviews. There are no honest reviews on consumer websites."
        }
      ]
    },
    {
      "id": 2,
      "text": "Question 2",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 3,
      "text": "Question 3",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 4,
      "text": "Question 4",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 5,
      "text": "Question 5",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/assessments/test-qa2.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa0b",
  "questions": [
    {
      "id": 743,
      "text": "This is a test assessment. Please select one of the options below:",
      "correct_answer": "A",
      "answers": [
        { "id": "A",
          "text": "This is a correct answer.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        },
        { "id": "A",
          "text": "This is a correct answer.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        },
        { "id": "A",
          "text": "This is a correct answer.",
          "correct": true,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "correct feedback"}]
              }]
            }
          }
        }
      ]
    }
  ]
}
  })();
});

require.register("local-data/poll_results/test-poll.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Checking accounts?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Very",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "Somewhat",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "Not at all",
                    "count": 3
                  }
                ]
              },
              {
                "id": 277,
                "text": "Money market accounts?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Very",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "Somewhat",
                    "count": 50
                  },
                  {
                    "id": 1084,
                    "text": "Not at all",
                    "count": 10
                  }
                ]
              },
              {
                "id": 278,
                "text": "Certificates of deposit?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Very",
                    "count": 15
                  },
                  {
                    "id": 1084,
                    "text": "Somewhat",
                    "count": 35
                  },
                  {
                    "id": 1084,
                    "text": "Not at all",
                    "count": 30
                  }
                ]
              },
              {
                "id": 279,
                "text": "Money market accounts?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Very",
                    "count": 19
                  },
                  {
                    "id": 1084,
                    "text": "Somewhat",
                    "count": 31
                  },
                  {
                    "id": 1084,
                    "text": "Not at all",
                    "count": 35
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/assessments/rec-m1-post.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa1b",
  "passing_grade": 70,
  "questions": [
    {
      "id": 1,
      "text": "Local sample for m1-post-assessment. Since online sellers can duplicate reviews to bump their ratings, what can you do to make sure you are reading authentic reviews of a product?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Read the reviews of the item on many different websites to see if they are consistent or agree with each other."
        },
        {
          "id": "B",
          "text": "Only read reviews from the advertisers or the store website where you are buying it."
        },
        {
          "id": "C",
          "text": "Read reviews only by social media influencers and their followers."
        },
        {
          "id": "D",
          "text": "Don't read online reviews. There are no honest reviews on consumer websites."
        }
      ]
    },
    {
      "id": 2,
      "text": "Question 2",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 3,
      "text": "Question 3",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 4,
      "text": "Question 4",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 5,
      "text": "Question 5",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/assessments/rec-m1-pre.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa1b",
  "passing_grade": 70,
  "questions": [
    {
      "id": 1,
      "text": "Local sample for m1-pre-assessment. Since online sellers can duplicate reviews to bump their ratings, what can you do to make sure you are reading authentic reviews of a product?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Read the reviews of the item on many different websites to see if they are consistent or agree with each other."
        },
        {
          "id": "B",
          "text": "Only read reviews from the advertisers or the store website where you are buying it."
        },
        {
          "id": "C",
          "text": "Read reviews only by social media influencers and their followers."
        },
        {
          "id": "D",
          "text": "Don't read online reviews. There are no honest reviews on consumer websites."
        }
      ]
    },
    {
      "id": 2,
      "text": "Question 2",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 3,
      "text": "Question 3",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 4,
      "text": "Question 4",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 5,
      "text": "Question 5",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/assessments/test-qa.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa0b",
  "questions": [
    {
      "id": 743,
      "text": "This is a test assessment. Please select one of the options below:",
      "correct_answer": "C",
      "answers": [
        { "id": "A",
          "text": "This is an incorrect answer.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        },
        { "id": "B",
          "text": "This is also an incorrect answer.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        },
        { "id": "C",
          "text": "This is a correct answer",
          "correct": true,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "correct feedback"}]
              }]
            }
          }
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/assessments/primitives-assessment-1.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa0b",
  "questions": [
    {
      "id": 743,
      "text": "When you take out a student loan, why do you end up repaying more than you originally borrowed?",
      "correct_answer": "D",
      "answers": [
        { "id": "A",
          "text": "Because you were never told the original loan amount.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        },
        { "id": "B",
          "text": "Because you shortened the term of your loan plan.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        },
        { "id": "C",
          "text": "Because you are paying the principal in addition to the original loan amount.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        },
        { "id": "D",
          "text": "Because you pay interest on a student loan. ",
          "correct": true,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "correct feedback"}]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 744,
      "text": "Loan repayment methods are designed to help you repay your student loan given different stages of financial stability. When monthly loan payments increase over time, that method is known as",
      "correct_answer": "B",
      "answers": [
        {"id": "A", "text": "Standard"},
        {"id": "B", "text": "Graduated"},
        {"id": "C", "text": "Capitalized interest"},
        {"id": "D", "text": "Discretionary income"}
      ]
    },
    {
      "id": 745,
      "text": "What should you do if you are having trouble making your monthly loan payments?",
      "correct_answer": "C",
      "answers": [
        {"id": "A", "text": "Just make the payments when you can"},
        {"id": "B", "text": "Stop making payments altogether"},
        {"id": "C", "text": "Call your servicer for help"},
        {"id": "D", "text": "Leave town and don’t provide a forwarding address"}
      ]
    }
  ]
}
  })();
});

require.register("local-data/assessments/rec-m2-post.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa1b",
  "passing_grade": 70,
  "questions": [
    {
      "id": 1,
      "text": "Local sample for m2-post-assessment. Since online sellers can duplicate reviews to bump their ratings, what can you do to make sure you are reading authentic reviews of a product?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Read the reviews of the item on many different websites to see if they are consistent or agree with each other."
        },
        {
          "id": "B",
          "text": "Only read reviews from the advertisers or the store website where you are buying it."
        },
        {
          "id": "C",
          "text": "Read reviews only by social media influencers and their followers."
        },
        {
          "id": "D",
          "text": "Don't read online reviews. There are no honest reviews on consumer websites."
        }
      ]
    },
    {
      "id": 2,
      "text": "Question 2",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 3,
      "text": "Question 3",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 4,
      "text": "Question 4",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 5,
      "text": "Question 5",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/assessments/rec-m3-post.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa1b",
  "passing_grade": 70,
  "questions": [
    {
      "id": 1,
      "text": "Local sample for m3-post-assessment. Since online sellers can duplicate reviews to bump their ratings, what can you do to make sure you are reading authentic reviews of a product?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Read the reviews of the item on many different websites to see if they are consistent or agree with each other."
        },
        {
          "id": "B",
          "text": "Only read reviews from the advertisers or the store website where you are buying it."
        },
        {
          "id": "C",
          "text": "Read reviews only by social media influencers and their followers."
        },
        {
          "id": "D",
          "text": "Don't read online reviews. There are no honest reviews on consumer websites."
        }
      ]
    },
    {
      "id": 2,
      "text": "Question 2",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 3,
      "text": "Question 3",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 4,
      "text": "Question 4",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 5,
      "text": "Question 5",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/assessments/rec-m2-pre.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa1b",
  "passing_grade": 70,
  "questions": [
    {
      "id": 1,
      "text": "Local sample for m2-pre-assessment. Since online sellers can duplicate reviews to bump their ratings, what can you do to make sure you are reading authentic reviews of a product?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Read the reviews of the item on many different websites to see if they are consistent or agree with each other."
        },
        {
          "id": "B",
          "text": "Only read reviews from the advertisers or the store website where you are buying it."
        },
        {
          "id": "C",
          "text": "Read reviews only by social media influencers and their followers."
        },
        {
          "id": "D",
          "text": "Don't read online reviews. There are no honest reviews on consumer websites."
        }
      ]
    },
    {
      "id": 2,
      "text": "Question 2",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 3,
      "text": "Question 3",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 4,
      "text": "Question 4",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    },
    {
      "id": 5,
      "text": "Question 5",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "A"
        },
        {
          "id": "B",
          "text": "B"
        },
        {
          "id": "C",
          "text": "C"
        },
        {
          "id": "D",
          "text": "D"
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/resources.json", function(exports, require, module) {
  module.exports = (function() {
return [
  {
    "id": 66,
    "type": "PolicyResource",
    "sub_type": "medical-amnesty-good-samaritan-policy",
    "default": false,
    "name": "Medical Amnesty Policy",
    "url": "http://simpsonswiki.com/wiki/Made-up_words",
    "body": "",
    "requires_link_click": true,
    "requires_e_signature": true,
    "resource_link_copy": "viewPolicy"
  },
  {
    "id": 67,
    "type": "PolicyResource",
    "sub_type": "honor-policy",
    "default": false,
    "name": "Honor Policy",
    "url": "http://simpsonswiki.com/wiki/Made-up_words",
    "body": "",
    "requires_link_click": true,
    "requires_e_signature": true,
    "resource_link_copy": "viewPolicy"
  },
  {
    "id": 68,
    "type": "PolicyResource",
    "sub_type": "alcohol-and-other-drug-policy",
    "default": false,
    "name": "Alcohol and Other Drug Policy",
    "url": "http://simpsonswiki.com/wiki/Made-up_words",
    "body": "This site helps people find alcohol and drug abuse treatment or mental health treatment facilities and programs around the country. It is sponsored by SAMHSA, The Substance Abuse and Mental Health Services Administration, an agency within the U.S. Department of Health and Human Services that aims to reduce the impact of substance abuse and mental illness on America's communities.",
    "requires_link_click": true,
    "requires_e_signature": true,
    "resource_link_copy": "viewPolicy"
  },
  {
    "id": 69,
    "type": "PolicyResource",
    "sub_type": "generic-policy",
    "name": "Campus Diversity",
    "url": "http://simpsonswiki.com/wiki/Made-up_words",
    "body": "This site helps people find alcohol and drug abuse treatment or mental health treatment facilities and programs around the country. It is sponsored by SAMHSA, The Substance Abuse and Mental Health Services Administration, an agency within the U.S. Department of Health and Human Services that aims to reduce the impact of substance abuse and mental illness on America's communities.",
    "requires_e_signature": false,
    "default": false,
    "signed_at": null,
    "signed": false,
    "signature_confirmed": false
  },
  {
    "id": 70,
    "type": "Resource",
    "sub_type": "Alcohol Policy",
    "default": false,
    "name": "A blank test test",
    "url": "http://simpsonswiki.com/wiki/Made-up_words",
    "body": "This site helps people find alcohol and drug abuse treatment or mental health treatment facilities and programs around the country. It is sponsored by SAMHSA, The Substance Abuse and Mental Health Services Administration, an agency within the U.S. Department of Health and Human Services that aims to reduce the impact of substance abuse and mental illness on America's communities.",
    "requires_e_signature": false
  },
  {
    "id": 71,
    "type": "Resource",
    "sub_type": "generic-policy",
    "name": "Title With e_sign",
    "url": "http://simpsonswiki.com/wiki/Made-up_words",
    "body": "This site helps people find alcohol and drug abuse treatment or mental health treatment facilities and programs around the country. It is sponsored by SAMHSA, The Substance Abuse and Mental Health Services Administration, an agency within the U.S. Department of Health and Human Services that aims to reduce the impact of substance abuse and mental illness on America's communities.",
    "requires_e_signature": false,
    "default": false,
    "signed_at": null,
    "signed": false
  },
  {
    "id": 72,
    "type": "Resource",
    "sub_type": "generic-policy",
    "name": "Title Without e_sign",
    "url": "http://simpsonswiki.com/wiki/Made-up_words",
    "body": "This site helps people find alcohol and drug abuse treatment or mental health treatment facilities and programs around the country. It is sponsored by SAMHSA, The Substance Abuse and Mental Health Services Administration, an agency within the U.S. Department of Health and Human Services that aims to reduce the impact of substance abuse and mental illness on America's communities.",
    "requires_e_signature": false,
    "default": false,
    "signed_at": null,
    "signed": false
  },
  {
    "id": 24,
    "type": "Resource",
    "sub_type": "substance-resource-local",
    "name": "Substance 1: Made Up Words",
    "url": "http://simpsonswiki.com/wiki/Made-up_words",
    "body": "This site helps people find alcohol and drug abuse treatment or mental health treatment facilities and programs around the country. It is sponsored by SAMHSA, The Substance Abuse and Mental Health Services Administration, an agency within the U.S. Department of Health and Human Services that aims to reduce the impact of substance abuse and mental illness on America's communities."
  }, {
  "id": 25,
  "type": "Resource",
  "sub_type": "Substance Resource",
  "name": "Substance 2: BFC on the Simpsons (no body text)",
  "url": "http://simpsonswiki.com/wiki/Betty_Ford_Center",
  "body": "This site helps people find alcohol and drug abuse treatment or mental health treatment facilities and programs around the country. It is sponsored by SAMHSA, The Substance Abuse and Mental Health Services Administration, an agency within the U.S. Department of Health and Human Services that aims to reduce the impact of substance abuse and mental illness on America's communities.",
  "show_modal": false,
  "separate_resource_link": false
}, {
  "id": 26,
  "type": "Resource",
  "sub_type": "Substance Resource",
  "name": "Substance 3: NEW Substance Resource Test",
  "url": "http://www.everfi.com/",
  "body": "This site helps people find alcohol and drug abuse treatment or mental health treatment facilities and programs around the country. It is sponsored by SAMHSA, The Substance Abuse and Mental Health Services Administration, an agency within the U.S. Department of Health and Human Services that aims to reduce the impact of substance abuse and mental illness on America's communities."
}, {
  "id": 27,
  "type": "NationalResource",
  "sub_type": "national-resources",
  "name": "Substance Abuse Treatment Referral Locator",
  "url": "http://findtreatment.samhsa.gov/",
  "body": "This site helps people find alcohol and drug abuse treatment or mental health treatment facilities and programs around the country. It is sponsored by SAMHSA, The Substance Abuse and Mental Health Services Administration, an agency within the U.S. Department of Health and Human Services that aims to reduce the impact of substance abuse and mental illness on America's communities."
}, {
  "id": 28,
  "type": "NationalResource",
  "sub_type": "national-resources",
  "name": "The Center on Addiction and the Family (COAF, formerly known as the Children of Alcoholics Foundation)",
  "url": "http://www.phoenixhouse.org/family/center-on-addiction-and-the-family",
  "body": "The Center on Addiction and the Family (COAF, formerly known as the Children of Alcoholics Foundation) is a unit of Phoenix House, the nation’s leading provider of alcohol and drug abuse treatment and prevention services. Its mission is to ensure that individuals, families, and professionals receive information and services that support the healing process – for everyone."
}, {
  "id": 29,
  "type": "NationalResource",
  "sub_type": "national-resources",
  "name": "Alcoholics Anonymous (AA)",
  "url": "http://www.aa.org/",
  "body": "Alcoholics Anonymous (AA) is an international fellowship whose primary purpose is to help alcoholics achieve sobriety. It is available almost everywhere, and membership is open to anyone who wants to do something about his or her drinking problem."
}, {
  "id": 30,
  "type": "NationalResource",
  "sub_type": "national-resources",
  "name": "Al-Anon/Alateen",
  "url": "http://www.al-anon.alateen.org/",
  "body": "Al-Anon is an independent fellowship that helps relatives and friends of alcoholics. Al-Anon holds the view that alcoholism is a family illness. Groups share their experience, strength, and hope in order to aid recovery."
}, {
  "id": 31,
  "type": "NationalResource",
  "sub_type": "national-resources",
  "name": "National Drug Treatment Referral Routing Service – 1-800-662-HELP (4357)",
  "url": "http://www.samhsa.gov/find-help/national-helpline",
  "body": "The Substance Abuse and Mental Health Services Administration's (SAMHSA) toll-free telephone number for alcohol and drug information and local treatment referral assistance. Open 24 hours a day, 7 days a week."
}, {
  "id": 32,
  "type": "NationalResource",
  "sub_type": "national-resources",
  "name": "Adult Children of Alcoholics World Service Organization, Inc.",
  "url": "http://www.adultchildren.org/",
  "body": "Adult Children of Alcoholics is an anonymous program of women and men who grew up in an alcoholic or otherwise dysfunctional home. The program gathers and disseminates meeting information for members; creates and distributes literature for use in groups, and provides information to the general public."
}, {
  "id": 33,
  "type": "NationalResource",
  "sub_type": "self-care-resources-global",
  "name": "21 Day Self-Care Challenge",
  "url": "https://www.movetoendviolence.org/resources/21-day-self-care-resources-challenge-packet/",
  "body": "The organization Move to End Violence created this 21-day challenge packet that breaks down self-care-resources practices into manageable daily goals."
}, {
  "id": 34,
  "type": "NationalResource",
  "sub_type": "self-care-resources",
  "name": "Self-Care Strategies for Survival",
  "url": "https://www.compasspoint.org/blog/self-care-resources-strategies-survival-sustaining-oneself-social-justice-movements",
  "body": "An insightful article on self-care-resources strategies from Lauren Lofton, JD."
}, {
  "id": 35,
  "type": "NationalResource",
  "sub_type": "self-care-resources",
  "name": "#SelfCare",
  "url": "http://truluv.ai/selfcare",
  "body": "This free game for your phone lets you explore self-care-resources practices."
}, {
  "id": 36,
  "type": "NationalResource",
  "sub_type": "self-care-resources",
  "name": "Getting Started with Mindfulness",
  "url": "https://www.mindful.org/meditation/mindfulness-getting-started/",
  "body": "The basics of mindfulness and meditation from Mindful.org."
}, {
  "id": 37,
  "type": "NationalResource",
  "sub_type": "self-care-resources",
  "name": "Mindfulness Coach",
  "url": "https://mobile.va.gov/app/mindfulness-coach",
  "body": "Created by the U.S. Department for Veterans Affairs, this free app is designed for anyone who wants to learn mindfulness and relaxation skills."
}, {
  "id": 38,
  "type": "NationalResource",
  "sub_type": "self-care-resources",
  "name": "Emm's Positivity Blog",
  "url": "https://positivedoodles.tumblr.com/",
  "body": "Illustrations and daily musings from an artist who lives with chronic illness."
}, {
  "id": 39,
  "type": "NationalResource",
  "sub_type": "substance-resource-global",
  "name": "Noisli",
  "url": "https://www.noisli.com/",
  "body": "Mix ambient sounds to create an environment that helps you be productive or relax."
}, {
  "id": 40,
  "type": "NationalResource",
  "sub_type": "self-care-resources-global",
  "name": "10 Things Worth Trying During Times of Stress, Trauma, or Crisis",
  "url": "https://www.upworthy.com/10-things-worth-trying-during-times-of-stress-trauma-or-crisis",
  "body": "This collection of tips from Upworthy includes helpful pointers and cute animal gifs."
}, {
  "id": 41,
  "type": "NationalResource",
  "sub_type": "substance-resource-global",
  "name": "The Importance of Self-Care",
  "url": "https://www.ted.com/playlists/299/the_importance_of_self_care",
  "body": "This playlist of talks from TED includes a variety of perspectives on self-care-resources."
}, {
  "id": 42,
  "type": "Resource",
  "sub_type": "self-care-resources-local",
  "name": "10 Things Worth Trying During Times of Stress, Trauma, or Crisis",
  "url": "https://www.upworthy.com/10-things-worth-trying-during-times-of-stress-trauma-or-crisis",
  "body": "This collection of tips from Upworthy includes helpful pointers and cute animal gifs."
}, {
  "id": 43,
  "type": "NationalResource",
  "sub_type": "More-to-explore",
  "name": "Substance Abuse Treatment Referral Locator",
  "url": "http://findtreatment.samhsa.gov",
  "body": ""
}, {
  "id": 44,
  "type": "NationalResource",
  "sub_type": "More-to-explore",
  "name": "The Center on Addiction and the Family (COAF, formerly known as the Children of Alcoholics Foundation)",
  "url": "http://www.phoenixhouse.org/family/center-on-addiction-and-the-family",
  "body": ""
}, {
  "id": 45,
  "type": "NationalResource",
  "sub_type": "More-to-explore",
  "name": "The Center on Addiction and the Family (COAF, formerly known as the Children of Alcoholics Foundation)",
  "url": "http://www.aa.org",
  "body": ""
}, {
  "id": 46,
  "type": "NationalResource",
  "sub_type": "More-to-explore",
  "name": "The Center on Addiction and the Family (COAF, formerly known as the Children of Alcoholics Foundation)",
  "url": "http://www.al-anon.alateen.org",
  "body": ""
}, {
  "id": 47,
  "type": "NationalResource",
  "sub_type": "more-to-explore-global",
  "name": "National Drug Treatment Referral Routing Service – 1-800-662-HELP (4357)",
  "url": "http://www.samhsa.gov/find-help/national-helpline",
  "body": ""
}, {
  "id": 48,
  "type": "NationalResource",
  "sub_type": "more-to-explore-global",
  "name": "Adult Children of Alcoholics World Service Organization, Inc.",
  "url": "http://www.adultchildren.org",
  "body": ""
}
]

  })();
});

require.register("local-data/polls/poll-demo.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-budgeting-for-mortgage",
        "name": "Budgeting for Mortgage",
        "description": "Budgeting for Mortgage",
        "title": "Budgeting for Mortgage",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Budgeting for Mortgage",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "I keep a record of what I earn each month.",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "I borrow someone elses Disney+ subscription",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "I am a cable cutter",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

